module.exports = __webpack_public_path__ + "img/level-locked.8eb51e66.svg";